import InputError from '@/Components/InputError';
import PrimaryButton from '@/Components/PrimaryButton';
import TextInput from '@/Components/TextInput';
import { useForm } from '@inertiajs/react';
import { FormEventHandler } from 'react';
import Head from "@/Molecules/Inertia/Head";
import {relativeRoute} from "@/helpers/relativeRoute";
import Page from "@/Pages/Page";

export default function ForgotPassword({ status }: { status?: string }) {
    const { data, setData, post, processing, errors } = useForm({
        email: '',
    });

    const submit: FormEventHandler = (e) => {
        e.preventDefault();

        post(relativeRoute('password.email'));
    };

    return (
      <Page title={"Forgot Password"}>

        <section>
          <div className={'container'}>

            <h1 className={'text-center'}>Wachtwoord herstellen</h1>



          </div>
          <div className="container !max-w-xl">
            {status && <div className="mb-4 font-medium text-sm text-green-600">{status}</div>}

            <form onSubmit={submit} className={' px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg'}>

              <p className="mb-4 text-sm text-gray-600">
                <p>
                  Wachtwoord vergeten? Geen probleem. <br />
                  Geef hier je e-mailadres in en we sturen je een link via
                  mail waarmee je een nieuw wachtwoord kan instellen.
                </p>
              </p>
              <TextInput
                id="email"
                type="email"
                name="email"
                value={data.email}
                className="mt-1 block w-full"
                isFocused={true}
                placeholder={'Je email adres'}
                onChange={(e) => setData('email', e.target.value)}
              />

              <InputError message={errors.email} className="mt-2"/>

              <div className="flex items-center justify-end mt-4">
                <PrimaryButton className="ms-4" disabled={processing}>
                  Email wachtwoord herstel link
                </PrimaryButton>
              </div>
            </form>

          </div>
        </section>
      </Page>
    );
}
